// extracted by mini-css-extract-plugin
export var chevron = "_mg-2";
export var chevronRotated = "_mg-3";
export var header = "_mg-1";
export var section = "_mg-0";